import axios from "axios";
import { useEffect } from "react";
import config from "src/config";

const DAM_API_URL = config.DAM_HOST_API_URL;
const POST_API_URL = config.POST_HOST_API_URL;
const CAMERA_API_URL = config.CAMERA_HOST_API_URL;
const SENSORTHING_API_URL = config.SENSORTHING_HOST_API_URL;
const AUTH_API_URL = config.AUTH_HOST_API_URL;

// ========================
// Tạo các instance API
// ========================
export const damApi = axios.create({
  baseURL: DAM_API_URL,
  timeout: 10000,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

export const postApi = axios.create({
  baseURL: POST_API_URL,
  timeout: 10000,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

export const cameraApi = axios.create({
  baseURL: `${CAMERA_API_URL}/api/v1`,
  timeout: 10000,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

export const sensothingRynanApi = axios.create({
  baseURL: SENSORTHING_API_URL,
  timeout: 10000,
  headers: {
    "x-api-key": config.RYNAN_X_API_KEY,
    "Content-Type": "application/json",
  },
});

export const authApi = axios.create({
  baseURL: `${AUTH_API_URL}/api/v1`,
  timeout: 10000,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

// ========================
// Middleware: Tự động gắn token vào request
// ========================
export const useAuthMiddleware = (token: string | null) => {
  useEffect(() => {
    const apiList = [damApi, cameraApi, postApi];

    apiList.forEach((apiInstance) => {
      // 🧹 Xóa interceptor cũ (nếu có)
      apiInstance.interceptors.request.clear();
      apiInstance.interceptors.response.clear();

      // 🧩 Interceptor request — gắn token mới
      apiInstance.interceptors.request.use(
        (config) => {
          const accessToken = token || localStorage.getItem("access_token");
          if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
          }
          return config;
        },
        (error) => Promise.reject(error)
      );

      // 🧩 Interceptor response — xử lý lỗi
      apiInstance.interceptors.response.use(
        (response) => response,
        (error) => {
          const status = error.response?.status;

          if (status === 401) {
            console.warn("⚠️ Token hết hạn hoặc không hợp lệ → đăng xuất");
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            window.location.href = "/login";
          }

          return Promise.reject(error);
        }
      );
    });
  }, [token]); // chạy lại khi token đổi
};
